import { Button, ButtonProps } from '@chakra-ui/react'
import React from 'react'

const BaseSubmitButton: React.FC<ButtonProps> = ({ children, ...props }) => {
  return <Button {...props}>{children}</Button>
}

export default BaseSubmitButton
